import Container from '@mui/material/Container';

import { paths } from 'src/routes/paths';

import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';

import StationeryStockCountNewEditForm from '../stationery-stock-count-new-edit-form';

export default function StationeryStockCountCreateView() {
  const settings = useSettingsContext();

  return (
    <Container maxWidth={settings.themeStretch ? false : 'lg'}>
      <CustomBreadcrumbs
        heading="Create a new stock count"
        links={[
          {
            name: 'Stock Count',
            href: paths.dashboard.stationeryStockCount.root,
          },
          { name: 'Create a new stock count' },
        ]}
        sx={{
          mb: { xs: 3, md: 5 },
        }}
      />

      <StationeryStockCountNewEditForm />
    </Container>
  );
}
